import "./../images/_index";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import AllPages from "./all-pages";
import Animations from "./animations";
import { FormAsync } from "./form-async";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

try {
  (() => {
    AllPages();
    Animations();
    // Common();
    FormAsync();
    // switch (document.body.id) {
    //   // case "home-body":
    //   //   Home();
    //   //   break;
    //   }
    //   // Home();
    // Animations();
  })();
} catch (err: any) {
  console.error(err);
}
